import React, { useState } from "react";
import Chunk from "./Chunk";

import { QuizObjectChunk } from "../../../../../../store/modquiz/quiz_objects/quiz-object";
import { observer } from "mobx-react";

import "./style.css";
interface ChunksProps {
    chunks: Array<QuizObjectChunk>;
    quiz_object: any;
    focusField: (fieldName: string, id?: string) => void;
    blurField: (event: React.FocusEvent<any>) => void;
    subjectHashKey: string;
}

const Chunks = observer(
    ({ quiz_object, chunks, focusField, blurField, subjectHashKey }: ChunksProps) => {
        const [focus, setFocus] = useState<number | undefined>(undefined);

        const addChunk = () => {
            quiz_object.addChunk();
            setFocus(chunks.length);
        };

        return (
            <div>
                {chunks.map((chunk, i: number) => {
                    if (chunk.deleted) {
                        return
                    }
                    return (
                        <Chunk
                            key={i}
                            subjectHashKey={subjectHashKey}
                            chunk={chunk}
                            focusOn={focus}
                            thisIndex={i}
                            addChunk={() => addChunk()}
                            focusField={focusField}
                            blurField={blurField}
                            focusNextField={() => setFocus(i + 1)}
                            focusPreviousField={() => setFocus(i - 1)}
                        />
                    );
                })}
                <div className="add-chunk-space" onClick={addChunk} />
            </div>
        );
    }
);

export default Chunks;
